// W2.4 — câu mô tả sự kiện hoạt động của hội thoại (nhật ký cục bộ do SDK suy ra). Logic thuần, không đụng DOM.
import type { LocalActivity } from '@swchat/client-sdk';
import type { MemberRole } from '@swchat/protocol';
import { ROLE_LABEL } from './group';

/**
 * "An đã thêm Bình", "Bình đã rời nhóm", "An đã đổi tên nhóm thành “X”"… `name(id)` trả tên hiển thị (mình → "Bạn").
 * Không biết người thực hiện (đổi vai trò thấy qua dữ liệu server) → câu bị động.
 */
export function activityText(a: LocalActivity, name: (userId: string) => string): string {
  const actor = a.actor ? name(a.actor) : undefined;
  const subject = a.subject ? name(a.subject) : '…';
  switch (a.kind) {
    case 'member_added':
      return `${actor ?? 'Có người'} đã thêm ${subject}`;
    case 'member_removed':
      return `${actor ?? 'Có người'} đã xóa ${subject} khỏi nhóm`;
    case 'member_left':
      return `${subject} đã rời nhóm`;
    case 'renamed':
      return `${actor ?? 'Có người'} đã đổi tên nhóm thành “${a.detail ?? ''}”`;
    case 'role_changed': {
      const role = ROLE_LABEL[a.detail as MemberRole] ?? a.detail ?? '';
      return actor ? `${actor} đã đổi vai trò của ${subject} thành ${role}` : `${subject} được đổi vai trò thành ${role}`;
    }
    case 'pinned':
      return `${actor ?? 'Có người'} đã ghim một tin nhắn`;
    case 'unpinned':
      return `${actor ?? 'Có người'} đã bỏ ghim một tin nhắn`;
    default:
      return 'Hoạt động';
  }
}
